import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import w, { forwardRef as v, useRef as y } from "react";
import { m as l } from "./mobile-BpUO1OTk.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { m as j } from "./tss-DN0acMKN.mjs";
import { M as S, d as b } from "./constants-CnFYFetN.mjs";
import { u as C } from "./use-screen-sizes-hx44ztp3.mjs";
import { I as N } from "./BamboohrLogo115x17-IIZ1wwB2.mjs";
const D = j()(({ palette: r, breakpoints: o, mode: n, mixins: i, constructs: c, layout: d }, { borderTop: s, dark: a }) => ({
  root: {
    /* @startCleanup encore */
    minHeight: e.ifFeature("encore", void 0, 92),
    borderColor: e.ifFeature("encore", void 0, r.gray[300]),
    /* @endCleanup encore */
    width: "100%",
    backgroundColor: e.ifFeature(
      "encore",
      a ? c.surface.neutral.xxStrong : c.surface.neutral.xxWeak,
      a ? "black" : r.gray[100]
    ),
    outline: n === S.Dye ? `1px solid ${b.main}` : void 0,
    borderTop: e.ifFeature("encore", "1px solid transparent", "solid 1px"),
    boxShadow: e.ifFeature("encore", "0 0 transparent"),
    transition: "border-top 0.3s ease, box-shadow 0.3s ease",
    [o.down(l)]: {
      flexDirection: e.ifFeature("encore", "row", "column")
    }
  },
  rootBorder: {
    borderTop: s ? e.ifFeature("encore", `1px solid ${i.alpha(c.border.neutral.strong, 0.2)}`) : void 0,
    boxShadow: s ? e.ifFeature("encore", `0 -2px 1px -1px ${i.alpha(c.border.neutral.strong, 0.05)}`) : void 0
  },
  content: {
    display: "flex",
    /* @startCleanup encore */
    margin: e.ifFeature("encore", void 0, "0 auto"),
    /* @endCleanup encore */
    maxWidth: e.ifFeature("encore", "none", 1348),
    justifyContent: "space-between",
    [o.down(l)]: {
      flexDirection: "column"
    },
    alignItems: e.ifFeature("encore", "center"),
    padding: e.ifFeature("encore", `${d.pageCapsule.paddingY}px ${d.pageCapsule.padding}px`)
  },
  left: {
    display: "flex",
    [o.down(l)]: {
      justifyContent: "center",
      flexDirection: e.ifFeature("encore", "row", "column")
    }
  },
  actions: {
    color: a ? "white" : "black",
    /* @startCleanup encore */
    padding: e.ifFeature("encore", void 0, "24px 16px 32px 32px"),
    /* @endCleanup encore */
    display: e.ifFeature("encore", "flex"),
    alignItems: e.ifFeature("encore", "center"),
    gap: e.ifFeature("encore", "16px"),
    [o.down(l)]: {
      display: "flex",
      flexDirection: e.ifFeature("encore", "row", "column"),
      flexWrap: e.ifFeature("encore", "wrap"),
      justifyContent: "center",
      width: "auto",
      /* @startCleanup encore */
      padding: e.ifFeature("encore", void 0, "24px 32px 0px 32px"),
      /* @endCleanup encore */
      "& button": {
        marginBottom: "10px",
        marginLeft: "0"
      }
    }
  },
  children: {
    color: a ? "white" : "black",
    padding: e.ifFeature("encore", "0 0 0 32px", "30px 0 47px 32px"),
    alignSelf: e.ifFeature("encore", "center"),
    [o.down(l)]: {
      flexDirection: e.ifFeature("encore", "row", "column"),
      height: "auto",
      padding: e.ifFeature("encore", "0", "30px 0 47px 32px")
    }
  },
  right: {
    /* @startCleanup encore */
    padding: e.ifFeature("encore", void 0, "31px 32px 45px 0"),
    /* @endCleanup encore */
    [o.down(l)]: {
      justifyContent: "center",
      margin: "0 auto",
      padding: e.ifFeature("encore", "0", "0 0 32px")
    }
  },
  icon: {
    fill: a ? "white" : r.gray[800]
  }
})), z = v((r, o) => {
  var u, x, m, p, g;
  const { classes: n, cx: i } = D(r), c = y(null);
  o = o ?? c;
  const { isMediumScreen: d } = C(!0), s = e.ifFeature(
    "encore",
    null,
    /* @__PURE__ */ t.jsx("div", { className: n.icon, children: /* @__PURE__ */ t.jsx(N, {}) })
  ), a = r.children ? /* @__PURE__ */ t.jsx("div", { className: n.children, children: r.children }) : null, h = r.actions.map((f) => {
    const { children: F } = f.props;
    return w.cloneElement(
      f,
      { dark: r.dark, size: "large", noSpacing: d, ...f.props },
      F
    );
  });
  return /* @__PURE__ */ t.jsx(
    "div",
    {
      className: i(n.root, (u = r.classes) == null ? void 0 : u.root, { [n.rootBorder]: r.borderTop }),
      "data-fabric-component": "ActionFooter",
      ref: o,
      children: /* @__PURE__ */ t.jsxs("div", { className: i(n.content, (x = r.classes) == null ? void 0 : x.content), children: [
        /* @__PURE__ */ t.jsxs("div", { className: i(n.left, (m = r.classes) == null ? void 0 : m.left), children: [
          /* @__PURE__ */ t.jsx("div", { className: i(n.actions, (p = r.classes) == null ? void 0 : p.actions), children: h }),
          a
        ] }),
        /* @__PURE__ */ t.jsx("div", { className: i(n.right, (g = r.classes) == null ? void 0 : g.right), children: typeof r.right < "u" ? r.right : s })
      ] })
    }
  );
});
export {
  z as A
};
//# sourceMappingURL=action-footer-BTIroTk5.mjs.map
